import Feedback from './Feedback.vue'
import HorizontalBar from 'macarons-graphs-front/src/graph/HorizontalBar.js'

export default {
  id: 'feedback',
  label: 'Feedback',
  component: Feedback,
  dimensions: 1,
  adaptater: (data, vue) => {
    return HorizontalBar.adaptater(data, vue)
  }
}



// WEBPACK FOOTER //
// ./src/graphs/Feedback.js